import { Icon } from "../icons/Icon";

const Required = () => {
  return <Icon name="asterisk" className="size-2 text-ib-red-dark" />;
};

export default Required;
